import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const OnboardingMembersComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "OnboardingMembersPage" */ "@circle-react/components/SettingsApp/Onboarding"
    ),
);

export const OnboardingMembersPage = () => (
  <Suspense fallback={<PageLoader />}>
    <OnboardingMembersComponent />
  </Suspense>
);
